module.exports = __webpack_public_path__ + "static/media/cluster_narcity.992494e8.png";